export default [
    {value: "departure", label: "search_results.sort_by.departure_time"},
    {value: "price", label: "search_results.sort_by.price"},
    {value: "travel_time", label: "search_results.sort_by.travel_time"},
    {value: "rating", label: "search_results.sort_by.rating"},
];